<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <vggrid ref="xGrid" :list="list" tableheight="700" flexname=""
            :cols="cols" :showfooter="false" :showPage="true" :resizable="true" :total="query.total"
            :needBlackRow="false"
            :needPopMenu="true"
            :canbeEdit="true"
            @cellClick="cellClick" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
          <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
          </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'roleIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'rolecomtype', fieldtype: 'C', title: '类型',syscode: 'cositemcomtype', calculExpr:'',editRender: { name: 'select', options: []}},
          { field: 'roletype', fieldtype: 'C', title: '类型',syscode: 'roletype', calculExpr:'',editRender: { name: 'select', options: []}},
          { field: 'rolename', fieldtype: 'C', title: '名称',calculExpr:'',editRender: { name: 'input'}},
          { field: 'roleremark', fieldtype: 'C',title: '备注',calculExpr:'',editRender: { name: 'input'}}
        ],
        role: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    activated() {
      this.getPageList()
    },
    created () {
      this.$on('SAV', () => this.addOrEdit())
      this.$on('DEL', () => this.delRole())
      this.$on('AUTH', () => this.roleAuthForm())
      this.$on('RAUTH', () => this.roleAuthReport())
      this.$on('CLOSE', () => this.close())
    },
    mounted () {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.role = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async roleAuthForm () {
        if (!this.role.roleid) {
          this.$message.warning('请选择一个角色!')
          return
        }
        this.$router.push({name: 'roleAuthForm', params: {form: this.role}})
      },
      async roleAuthReport () {
        if (!this.role.roleid) {
          this.$message.warning('请选择一个角色!')
          return
        }
        this.$router.push({name: 'roleAuthReport', params: {form: this.role}})
      },
      async delRole () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/role/delRole',
            method: "post",
            data: this.role
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error('删除失败！')
          }
        })
      },
      async cellClick (row) {
        this.role = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async addOrEdit () {
        let model = this.$refs.xGrid.$refs.xGrid.getRecordset()
        let data = await request({
          url: '/xtgl/role/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          await this.getPageList()
          this.$message.success('保存成功！')
        } else {
          this.$message.error('保存失败!')
        }
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/role/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
